// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart{flex:0 0 100%;height:300px;width:100%;background-color:#fff}.right{float:right;margin-top:5px;margin-right:2px}.center{text-align:center;font-size:20px}.google-visualization-tooltip{pointer-events:none}", ""]);
// Exports
module.exports = exports;
